import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { useToast } from '../../hooks/use-toast';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { RefreshCw, Eye } from 'lucide-react';
import { INQUIRY_STATUSES, labelFor, receptionApiErrorMessage } from './receptionConstants';

const BUCKETS = [
  { key: 'today', label: "Today's Follow-ups" },
  { key: 'upcoming', label: 'Upcoming' },
  { key: 'missed', label: 'Missed' },
  { key: 'completed', label: 'Completed' },
];

export default function ReceptionFollowups() {
  const { toast } = useToast();
  const [bucket, setBucket] = useState('today');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const res = await api.get('/reception/followups', { params: { bucket } });
      setItems(res.data?.data?.items || []);
    } catch (e) {
      setItems([]);
      toast({ title: 'Error', description: receptionApiErrorMessage(e), variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, [bucket]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div><h1 className="text-2xl font-bold">Follow-ups</h1><p className="text-muted-foreground">Track admission inquiry follow-ups</p></div>
        <Button variant="outline" size="icon" onClick={fetchItems}><RefreshCw className="w-4 h-4" /></Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {BUCKETS.map((b) => (
          <Button key={b.key} variant={bucket === b.key ? 'default' : 'outline'} onClick={() => setBucket(b.key)}>
            {b.label}
          </Button>
        ))}
      </div>
      <Card>
        <CardHeader><CardTitle>{BUCKETS.find((b) => b.key === bucket)?.label}</CardTitle></CardHeader>
        <CardContent>
          {loading ? <p className="text-muted-foreground">Loading…</p> : items.length === 0 ? (
            <p className="text-muted-foreground">No follow-ups in this category.</p>
          ) : (
            <table className="w-full text-sm">
              <thead><tr className="border-b text-left text-muted-foreground">
                <th className="py-2">Student</th><th className="py-2">Status</th><th className="py-2">Follow-up Date</th>
                <th className="py-2">Counselor</th><th className="py-2">Actions</th>
              </tr></thead>
              <tbody>
                {items.map((r) => (
                  <tr key={r.id} className="border-b border-border/50">
                    <td className="py-2 font-medium">{r.student_name}</td>
                    <td className="py-2">{labelFor(INQUIRY_STATUSES, r.status)}</td>
                    <td className="py-2">{r.next_followup_date || '—'}</td>
                    <td className="py-2">{r.assigned_to_name || '—'}</td>
                    <td className="py-2">
                      <Button variant="ghost" size="sm" asChild><Link to={`/reception/inquiries/${r.id}`}><Eye className="w-4 h-4" /></Link></Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
